import SelectMapper   from './../mapper/select-mapper'
import ResourceGetter from './../resource/getter/resource-getter'

export default new class SourceLoader {

  /**
   * v successCallbacku vrati kolekci polozek pro autocomplete + dropdown
   * [{value: *, label: *}]
   * @param args
   * @param succesCallback
   * @param errorCallback
   * @return axios
   */
  load (args, succesCallback, errorCallback) {
    if (typeof succesCallback !== 'function') {
      throw Error('Param Error: successCallback must be callable function')
    }

    let queries  = SourceLoader._prepareParams(args),
        resource = ResourceGetter.get(args.source)

    delete queries.limit
    delete queries.where

    return resource
      .setDef(args.def)
      .getAutocompleteData({ queries: queries, data: args.defaults })
      .then((response) => {
        let items = SelectMapper.map({ source: response.data })

        succesCallback(items, response.data)
      })
  }

  /**
   * v successCallbacku vrati objekt {value: * label: *}
   * @param args
   * @param succesCallback
   */
  get (args, succesCallback) {
    let Resource = ResourceGetter.get(args.source)

    Resource
      .getById(args.id, { idtEntity: args.idStructure })
      .then(response => {

        succesCallback(response.data)
      })
      .catch(error => {

      })
  }

  /**
   *
   * @param args
   * @return {{}}
   * @private
   */
  static _prepareParams (args) {
    let params = {
      limit:      null,
      where:      '',
      searchText: null,
      condition:  null,
      idtEntity:  null
    }

    if (args.hasOwnProperty('limit')) {
      params.limit = args.limit
    }

    if (args.hasOwnProperty('limit')) {
      params.pageSize = args.limit ? args.limit : null
    }

    if (args.hasOwnProperty('columnName')) {
      params.columnName = args.columnName
    }

    if (args.hasOwnProperty('where')) {
      params.where = args.where
    }

    params.searchText = args.searchText ? args.searchText : ''

    if (args.hasOwnProperty('condition')) {
      params.condition = args.condition
    }

    if (args.hasOwnProperty('idtEntity')) {
      params.idtEntity = args.idtEntity
    }

    if (args.hasOwnProperty('idtEntityStructureFrom')) {
      params.idtEntityStructureFrom = args.idtEntityStructureFrom
    }

    return params
  }

}
